module.exports = __webpack_public_path__ + "img/Mercury-full.abb30b86.png";